import { render, staticRenderFns } from "./DotHints.vue?vue&type=template&id=2d08f2e6&scoped=true&"
import script from "./DotHints.vue?vue&type=script&lang=js&"
export * from "./DotHints.vue?vue&type=script&lang=js&"
import style0 from "./DotHints.vue?vue&type=style&index=0&id=2d08f2e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08f2e6",
  null
  
)

export default component.exports